import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5050/api', // Your backend URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a "Request Interceptor" to attach the JWT token automatically
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use((response) => {
  return response;
}, error => {
  if (error.response && error.response.status === 401) {
    console.warn('Session expired (401). Clearing storage and redirecting...');

    // 1. Clear all authentication tokens from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('user');  // Clear user profile details too
    // Alternatively, use localStorage.clear(); if you want a total wipe

    // 2. Redirect to the login page
    // Forcing a window assignment cleanly resets the React application state memory
    window.location.href = '/login';
  }

  // Pass the error back down so components can still display local messages if needed
  return Promise.reject(error);
});

export default apiClient;